<template>
    <section class="about-brief">
        <div class="about-brief-content">
            <div class="about-brief-text">
                <div class="about-title-wrap">
                    <h2>关于我们</h2>
                    <span class="title-watermark">ABOUT US</span>
                </div>
                <p class="about-desc">
                    海南鼎昂建筑工程有限公司成立于2020年10月16日，总部位于海南省三亚市崖州区，是一家专注于土木工程建筑领域的综合服务商。公司注册资本1000万元人民币，持有建设工程施工、设计等多项资质及12项专利技术，业务涵盖市政工程、园林绿化、土石方施工、建材制造及物联网技术应用，近年深度参与海南自贸港重点项目如中山北路至疏港大道市政工程（EPC）的材料供应与施工协作。
                </p>
                <router-link to="/about" class="more-link">查看更多</router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AboutBrief',
};
</script>

<style scoped>
.about-brief {
    background: #fff;
    padding: 56px 0 48px 0;
    border-radius: 20px;
    box-shadow: 0 4px 24px rgba(30, 60, 120, 0.06);
    margin: 0 auto 40px auto;
    width: 100%;
    max-width: none;
    position: relative;
    overflow: hidden;
}

.about-title-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
    width: 100%;
}

.title-watermark {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -10px;
    font-size: 2.2rem;
    font-weight: 900;
    color: #1a2a47;
    opacity: 0.09;
    letter-spacing: 0.18em;
    user-select: none;
    pointer-events: none;
    z-index: 1;
    white-space: nowrap;
}

.about-title-wrap h2 {
    position: relative;
    z-index: 2;
    margin: 0;
    font-size: 2rem;
    font-weight: 700;
    color: #1a2a47;
    letter-spacing: 1px;
    text-align: center;
}

.about-brief-content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    max-width: 1200px;
    margin: 0 auto;
    gap: 0;
}

.about-brief-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.about-brief-text h2 {
    font-size: 2.1rem;
    font-weight: 700;
    color: #1a2a47;
    margin-bottom: 18px;
    letter-spacing: 1px;
}

.about-desc {
    font-size: 1.13rem;
    color: #333;
    line-height: 2;
    margin-bottom: 28px;
    text-align: justify;
}

.more-link {
    display: inline-block;
    background: #2563eb;
    color: #fff;
    border-radius: 22px;
    padding: 8px 32px;
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
    box-shadow: 0 2px 8px rgba(30, 60, 120, 0.10);
    transition: background 0.2s, transform 0.2s;
    letter-spacing: 1px;
    border: none;
}

.more-link:hover {
    background: #1a2a47;
    transform: translateY(-2px) scale(1.04);
}

@media (max-width: 768px) {
    .about-brief {
        padding: 28px 0 24px 0;
        border-radius: 10px;
        margin-bottom: 20px;
    }

    .about-brief-content {
        max-width: 98vw;
        padding: 0 8px;
    }

    .about-brief-text h2 {
        font-size: 1.2rem;
        margin-bottom: 10px;
    }

    .about-desc {
        font-size: 0.98rem;
        margin-bottom: 16px;
    }

    .more-link {
        font-size: 0.95rem;
        padding: 6px 18px;
        border-radius: 12px;
    }

    .about-title-wrap h2 {
        font-size: 1.18rem;
    }

    .title-watermark {
        font-size: 1.2rem;
    }
}
</style>